import { Component, CUSTOM_ELEMENTS_SCHEMA, EventEmitter, Input, Output } from '@angular/core';
import { STRIPE_DISCLOSURE_TEXT, STRIPE_URLS } from '../../../v2-layout/stripe-treasury/stripe-treasury.constants';

export interface BankAccountKycDialogResult {
    startVerification: boolean;
}

@Component({
    selector: 'app-bank-account-kyc-dialog',
    standalone: true,
    templateUrl: './bank-account-kyc-dialog.component.html',
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class BankAccountKycDialogComponent {
    @Input() open = false;
    @Output() readonly closed = new EventEmitter<BankAccountKycDialogResult>();

    readonly stripeUrls = STRIPE_URLS;
    readonly disclosureText = STRIPE_DISCLOSURE_TEXT.PARTNER_DISCLOSURE;
}
